import { makeStyles, mergeClasses } from '@griffel/react';
export const teachingPopoverCarouselCardClassNames = {
    root: 'fui-TeachingPopoverCarouselCard'
};
const useStyles = makeStyles({
    root: {}
});
/** Applies style classnames to slots */ export const useTeachingPopoverCarouselCardStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = mergeClasses(teachingPopoverCarouselCardClassNames.root, styles.root, state.root.className);
    return state;
};
